<dx-data-grid [dataSource]="data"
              [allowColumnReordering]="false"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [showBorders]="true"
              [width]="getGridWidth()"
              [hoverStateEnabled]="true"
              (onRowDblClick)="rowDblClick($event)">
  <dxi-column [cellTemplate]="'cellTemplateImage'" [fixed]="true">
    <div *dxTemplate="let row of 'cellTemplateImage'">
      <img [src]="getRowImage(row.data)" alt="" class="row-image"/>
    </div>
  </dxi-column>
  <dxi-column [cellTemplate]="'cellTemplateEdit'" [fixed]="true">
    <div *dxTemplate="let row of 'cellTemplateEdit'" (click)="edit(row.data)">
      <i class="dx-icon-edit edit-icon-cursor-style"></i>
    </div>
  </dxi-column>
  <ng-container *ngFor="let headerColumn of headerColumns">
    <dxi-column [caption]="headerColumn.DisplayName" [dataField]="headerColumn.FieldName" [dataType]="headerColumn.dataType" [format]="headerColumn.format"></dxi-column>
  </ng-container>
  <dxo-scrolling [columnRenderingMode]="'virtual'" [useNative]="true"></dxo-scrolling>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-paging [pageSize]="5"></dxo-paging>
  <dxo-pager [visible]="true"
             [allowedPageSizes]="allowedPageSizes"
             [displayMode]="pagerDisplayMode"
             [showPageSizeSelector]="true"
             [showInfo]="true"
             [showNavigationButtons]="true">
  </dxo-pager>
</dx-data-grid>
